<template>
  <div>
    <!--Breadcrumb button-->
    <breadcrumb-button hide-settings>
      <template #beforeDropdown>
        <b-button variant="success" class="btn-icon" v-b-tooltip v-bind:title="$t('operations.add')" @click="onAffiliateSelected(null)">
          <i class="fa-solid fa-plus"></i>
        </b-button>
        <b-button variant="primary" class="btn-icon mx-1" v-b-tooltip v-bind:title="$t('columns.self')"
                  @click="openColumnsModal">
          <i class="fa-solid fa-bars"></i>
        </b-button>
      </template>
      <template #items>
        <b-dropdown-item @click="openColumnsModal">
          <feather-icon
              icon="CheckSquareIcon"
              size="16"
          />
          <span class="align-middle ml-50">{{ $t('columns.self') }}</span>
        </b-dropdown-item>
      </template>
    </breadcrumb-button>
    <!--Filters-->
    <filter-card  v-model="filter" v-bind:fields="filterFields" search/>
    <!--Table Card-->
    <b-card no-body>
      <b-card-header class="pb-50">
        <h5>{{$t("menu.affiliates")}}</h5>
      </b-card-header>
      <b-card-body>
        <affiliates-table ref="affiliateTable" v-bind:filters="filter" v-bind:columns="columns" :has-selection="false" @selected="onAffiliateSelected" :lazy="true"/>
      </b-card-body>
    </b-card>
    <!--Modal-->
    <columns-modal ref="columns-modal" column-key="affiliates" v-model="columns"
                   v-bind:columns-names="columnsNames" />
    <affiliate-modal ref="affiliate-modal" />
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import BreadcrumbButton from '@/components/widget/breadcrumbButton'
import AffiliateSearchRequest from '@/model/affiliate/AffiliateSearchRequest'
import ColumnsModal from '@/components/modal/columnsModal'
import Affiliate from '@/model/affiliate/Affiliate'
import mixinPermissions from '@/components/mixin/mixinPermissions'
import mixinBase from '@/components/mixin/mixinBase'
import AffiliateModal from '@/components/modal/affiliateModal'
import FilterCard from '@/components/widget/FilterCard'
import AffiliateFilterFields from '@/model/filter/AffiliateFilterFields'
import AffiliatesTable from '@/components/tables/AffiliatesTable'

export default {
  name: 'AffiliatesView',
  components: {AffiliatesTable, FilterCard, AffiliateModal, ColumnsModal, BreadcrumbButton },
  mixins: [mixinBase,mixinPermissions],
  data() {
    return {
      columnsNames: ["company", "email", "branchId", "currentCpa.cpa", "currentCpa.crg"],
      filter: AffiliateSearchRequest(),
      filterLoaded: false,
      columns: [],
      filterFields: null,
    }
  },
  async created() {
    await this.refreshData()
    this.filterFields = AffiliateFilterFields();
  },
  computed: {
    ...mapGetters('data', ['allOrganizations']),
  },
  methods: {
    ...mapActions('affiliate', ['refreshData']),
    openColumnsModal() {
      this.$refs['columns-modal'].showModal()
    },
    onAffiliateSelected(selectedId) {
      // console.log("onAffiliateSelected", selectedId)
      this.$refs['affiliate-modal'].showModal(selectedId)
    },
  }
}
</script>

<style>
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  background: #dfe5fb;
  border: none;
  color: #394066;
  text-transform: lowercase;
  font-variant: small-caps;
  height: 10px;
}
</style>
